export const PLACE_HOLDER_EMPTY = 'N/A'
